module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card', {
    attrs: {
      "elevation12": ""
    }
  }, [_c('v-container', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-2"
  }, [_vm._v("Complete Registration")])]), _vm._v(" "), (!_vm.tokenValid) ? _c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.tokenInvalidMessage) + " ")])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Username",
      "readonly": "",
      "required": ""
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Password",
      "type": 'password',
      "rules": _vm.passwordRules,
      "required": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), (_vm.passwordValidationError) ? _c('v-list', [_vm._l((_vm.passwordErrors), function(item, index) {
    return [_c('v-list-tile', {
      attrs: {
        "color": "error"
      }
    }, [_c('v-list-tile-content', [_vm._v("\n                         " + _vm._s(item) + "\n                       ")])], 1)]
  })], 2) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "type": 'password',
      "rules": _vm.confirmPasswordRules,
      "required": ""
    },
    model: {
      value: (_vm.user.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.user, "confirmPassword", $$v)
      },
      expression: "user.confirmPassword"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.confirmUser
    }
  }, [_vm._v("Complete Registration")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6960846"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirmpage.vue
// module id = 1071
// module chunks = 2